const { setRuleValidator } = require('./utils/validation');

module.exports = {
  test({ params, rule }) {
    if (!params.hasOwnProperty(rule.arrayName)) {
      return false
    }

    const paramsArray = params[rule.arrayName];
    if (!Array.isArray(paramsArray)) {
      return false
    }

    const set = new Set(paramsArray);
    return rule.elements.every(item => set.has(item));
  },

  validate: setRuleValidator
};
